export default {
      id: "ticketswap-usage",
      viewBox: "0 0 380 250",
      url: "../../assets/" + "sprite.svg#ticketswap-usage",
      toString: function () {
        return this.url;
      }
    }